import React, { FC, useEffect, useState } from 'react';

import { getAppsCards } from 'client/api';
import { ErrorBoundary } from 'client/blocks/ErrorBoundary/ErrorBoundary';
import { PageLoader } from 'client/blocks-redesign/Loader/PageLoader';

import { Channel, IAppCard } from '../../model/skill';
import { AddNewAppCard } from '../AddNewAppCard/AddNewAppCard';
import { AppCard } from '../AppCard/AppCard';

import styles from './AppCardList.module.scss';

interface InstallableAppCardListProps {
    channel: Channel;
}

export const InstallableAppCardList: FC<InstallableAppCardListProps> = ({ channel }) => {
    const [cards, setCards] = useState<IAppCard[] | undefined>();

    useEffect(() => {
        const setup = async () => {
            const result = await getAppsCards({ channels: [channel] });
            if (result && result.cards) {
                setCards(result.cards);
            }
        };
        setup();
    }, [channel]);

    if (!cards) {
        return <PageLoader />;
    }

    return (
        <ErrorBoundary withHomepageLink>
            <div className={styles.installableAppCardList}>
                <AddNewAppCard aliceAppsCount={cards.length} channel={channel} />
                {cards.map((card) => (
                    <AppCard key={card.id} card={card} />
                ))}
            </div>
        </ErrorBoundary>
    );
};
